import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import Page from 'rui/widgets/Page'
import { BasicButton } from 'components/layout/buttons'
import Form from 'components/form'
import Input from 'components/form/Input'
import { exactLength } from 'components/form/validations'
import Thin from 'components/layout/Thin'
import Spacer from 'components/misc/Spacer'
import { sendMFA, verifyMFA } from 'actions/auth'
import { useLocalization, LocalizedText, LocalizedRichText } from 'localization'

const Countdown = (props) => {
  const { from, onComplete } = props
  const [current, setCurrent] = useState(from)

  const handleTick = useCallback(() => {
    if (current) {
      setCurrent((was) => was - 1)
    } else {
      onComplete()
    }
  }, [current, onComplete])

  useEffect(() => {
    const toid = setTimeout(handleTick, 1000)
    return () => {
      clearTimeout(toid)
    }
  })

  return <span>{current}</span>
}

const MFA = () => {
  const { t } = useLocalization()
  const dispatch = useDispatch()
  const mfa = useSelector((state) => state.mfa)
  const { guid, sent_to, sent_on, method } = mfa

  const [, setTick] = useState(1)

  const secondsAgo = Math.floor((new Date().getTime() - new Date(sent_on).getTime()) / 1000)
  const disabled = secondsAgo < 60
  const countdown = disabled ? (
    <span> ({<Countdown onComplete={() => setTick((t) => t + 1)} from={60 - secondsAgo} />})</span>
  ) : null

  // console.log({ sent_on, secondsAgo, disabled, countdown })

  const handleMFA = useCallback(
    (data) => {
      return dispatch(verifyMFA(guid, data.mfa_code))
    },
    [dispatch, guid]
  )

  const handleResend = useCallback(() => {
    dispatch(sendMFA(guid))
  }, [dispatch, guid])

  return (
    <Page>
      <Helmet>
        <title>{t('dweb_mfa_multifactor_authentication')}</title>
      </Helmet>
      <Thin>
        <Form onData={handleMFA} id="signin-form">
          <Panel>
            <PanelHeading>
              <LocalizedText translationKey="dweb_mfa_enter_method_code" params={{ method: method.toUpperCase() }} />
            </PanelHeading>
            <PanelSubheading>
              <LocalizedText translationKey="dweb_mfa_enter_code_sent_to" params={{ sentTo: sent_to }} />
            </PanelSubheading>

            <Input.Integer
              maxLength={6}
              className="fs-block"
              label={t('dweb_mfa_six_digit_code')}
              name="mfa_code"
              validate={exactLength(6).withMessage(t('dweb_validation_must_be_exactly_6_digits')).required()}
            />
            <Spacer />
            <div style={{ textAlign: 'left' }}>
              <BasicButton disabled={disabled} type="button" onClick={handleResend}>
                <LocalizedRichText translationKey="dweb_mfa_resend_code_countdown" params={{ countdown }} />
              </BasicButton>
            </div>

            <Input.Submit value={t('dweb_common_submit')} />
          </Panel>
        </Form>
      </Thin>
    </Page>
  )
}

export default MFA
